import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
const QuoteReceiptPricesContext = createContext({
  initialPrices: {},
  hidePricing: false
});
export const useQuoteReceiptProvider = () => {
  return useContext(QuoteReceiptPricesContext);
};
export const QuoteReceiptProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    initialPrices,
    hidePricing
  } = t0;
  let t1;
  if ($[0] !== initialPrices) {
    t1 = initialPrices ?? {};
    $[0] = initialPrices;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hidePricing || $[3] !== t1) {
    t2 = {
      initialPrices: t1,
      hidePricing
    };
    $[2] = hidePricing;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const value = t2;
  let t3;
  if ($[5] !== children || $[6] !== value) {
    t3 = <QuoteReceiptPricesContext.Provider value={value}>{children}</QuoteReceiptPricesContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};